(function() {
  if (window.__icePackUpsellLoaded) return;
  window.__icePackUpsellLoaded = true;

  var selectors = {
    root: '[data-ice-pack-upsell]',
    button: '[data-add-ice-pack]',
    error: '[data-ice-pack-error]'
  };

  var BUNDLE_THRESHOLD = 6;
  var BUNDLE_ONLY_THRESHOLD = 12;
  var addingIcePack = false;

  function toNumberList(value) {
    return String(value || '')
      .split(',')
      .map(function(item) { return Number(item.trim()); })
      .filter(function(item) { return Number.isFinite(item) && item > 0; });
  }

  function getRoots() {
    return Array.prototype.slice.call(document.querySelectorAll(selectors.root));
  }

  function getCartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) {
      return theme.routes.cartAdd;
    }

    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root + 'cart/add.js';
  }

  function getCartUrl() {
    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root + 'cart.js';
  }

  function getCartPageUrl() {
    if (window.theme && theme.routes && theme.routes.cartPage) {
      return theme.routes.cartPage;
    }

    var root = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/';
    return root + 'cart';
  }

  async function fetchJSON(url, init) {
    var response = await fetch(url, Object.assign({ credentials: 'same-origin' }, init || {}));
    var json = await response.json().catch(function() { return {}; });

    if (!response.ok || json.status === 422 || json.status === 'bad_request') {
      var message = json.description || json.message || 'Cart request failed.';
      throw new Error(message);
    }

    return json;
  }

  async function getCart() {
    return fetchJSON(getCartUrl(), {
      headers: { Accept: 'application/json' }
    });
  }

  function cartHasExcludedIcePack(cart, root) {
    var productIds = toNumberList(root.dataset.excludedProductIds);
    var variantIds = toNumberList(root.dataset.excludedVariantIds);

    return (cart.items || []).some(function(item) {
      var productId = Number(item.product_id || 0);
      var variantId = Number(item.variant_id || item.id || 0);

      return productIds.indexOf(productId) !== -1 || variantIds.indexOf(variantId) !== -1;
    });
  }

  function countEligibleCartQuantity(cart, root) {
    var productIds = toNumberList(root.dataset.excludedProductIds);
    var variantIds = toNumberList(root.dataset.excludedVariantIds);

    return (cart.items || []).reduce(function(total, item) {
      var productId = Number(item.product_id || 0);
      var variantId = Number(item.variant_id || item.id || 0);
      var isIcePack = productIds.indexOf(productId) !== -1 || variantIds.indexOf(variantId) !== -1;
      var isGiftCard = item.gift_card === true;
      var requiresShipping = item.requires_shipping !== false;

      if (isIcePack || isGiftCard || !requiresShipping) return total;

      return total + Number(item.quantity || 0);
    }, 0);
  }

  function isEligible(cart, root, eligibleQuantity) {
    if (!cart || Number(cart.item_count || 0) <= 0) return false;
    if (cartHasExcludedIcePack(cart, root)) return false;

    var quantity = typeof eligibleQuantity === 'number'
      ? eligibleQuantity
      : countEligibleCartQuantity(cart, root);

    if (quantity <= 0) return false;

    return quantity < BUNDLE_ONLY_THRESHOLD || !!root.querySelector('[data-ice-pack-button-type="bundle"]');
  }

  function setRootVisibility(root, visible) {
    root.hidden = !visible;
  }

  function updateButtonVisibility(root, eligibleQuantity) {
    var primaryButton = root.querySelector('[data-ice-pack-button-type="single"]');
    var bundleButton = root.querySelector('[data-ice-pack-button-type="bundle"]');
    var showBundle = eligibleQuantity >= BUNDLE_THRESHOLD && !!bundleButton;
    var showSingle = eligibleQuantity < BUNDLE_ONLY_THRESHOLD;
    var offerMode = 'single';

    if (showBundle && showSingle) {
      offerMode = 'two';
    } else if (showBundle) {
      offerMode = 'bundle';
    }

    root.dataset.offerMode = offerMode;

    if (primaryButton) {
      primaryButton.textContent = showBundle
        ? primaryButton.dataset.labelMultiple
        : primaryButton.dataset.labelSingle;
      primaryButton.hidden = !showSingle;
    }

    if (bundleButton) {
      bundleButton.hidden = !showBundle;
    }
  }

  async function syncOfferVisibility(cart) {
    var roots = getRoots();
    if (!roots.length) return;

    var currentCart = cart || await getCart();
    roots.forEach(function(root) {
      var eligibleQuantity = countEligibleCartQuantity(currentCart, root);
      updateButtonVisibility(root, eligibleQuantity);
      setRootVisibility(root, isEligible(currentCart, root, eligibleQuantity));
    });
  }

  function setRootLoading(root, loading) {
    root.dataset.loading = loading ? 'true' : 'false';

    root.querySelectorAll(selectors.button).forEach(function(button) {
      button.disabled = loading;
      button.classList.toggle('btn--loading', loading);
      button.setAttribute('aria-busy', loading ? 'true' : 'false');
    });
  }

  function setAllRootsLoading(loading) {
    getRoots().forEach(function(root) {
      setRootLoading(root, loading);
    });
  }

  function setError(root, message) {
    var error = root.querySelector(selectors.error);
    if (!error) return;

    if (message) {
      error.textContent = message;
      error.hidden = false;
    } else {
      error.hidden = true;
    }
  }

  async function addIcePack(root, button) {
    if (addingIcePack || root.dataset.loading === 'true') return;

    var variantId = Number(button.dataset.variantId || 0);
    if (!variantId) return;

    addingIcePack = true;
    setError(root, '');
    setAllRootsLoading(true);

    window.theme = window.theme || {};
    theme._atcSeq = (theme._atcSeq || 0) + 1;
    var atcSeq = theme._atcSeq;

    var payload = {
      items: [{
        id: variantId,
        quantity: 1,
        properties: {
          _source: button.dataset.source || root.dataset.source || 'cart_drawer',
          _added_by: 'ice_pack_upsell'
        }
      }],
      sections: 'cart-drawer-items',
      sections_url: getCartPageUrl()
    };

    try {
      var data = await fetchJSON(getCartAddUrl(), {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });

      getRoots().forEach(function(upsellRoot) {
        setRootVisibility(upsellRoot, false);
      });

      var product = Object.assign({}, data);
      var sections = product.sections;
      delete product.sections;

      document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
        detail: {
          product: product,
          addToCartBtn: button,
          sections: sections,
          source: 'ice-pack-upsell',
          _atcSeq: atcSeq
        }
      }));
    } catch (error) {
      console.warn('Ice pack add failed:', error);
      setError(root, 'We couldn’t add an ice pack right now. Please try again.');
    } finally {
      addingIcePack = false;
      setAllRootsLoading(false);
    }
  }

  function handleClick(event) {
    var button = event.target.closest(selectors.button);
    if (!button) return;

    var root = button.closest(selectors.root);
    if (!root) return;

    event.preventDefault();
    addIcePack(root, button);
  }

  function scheduleSync() {
    window.setTimeout(function() {
      syncOfferVisibility().catch(function(error) {
        console.warn('Ice pack offer visibility sync failed:', error);
      });
    }, 0);
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('DOMContentLoaded', scheduleSync);
  document.addEventListener('CartDrawer:open', scheduleSync);
  document.addEventListener('cart:rendered', scheduleSync);
  document.addEventListener('cart:updated', function(event) {
    if (event.detail && event.detail.cart) {
      syncOfferVisibility(event.detail.cart).catch(function(error) {
        console.warn('Ice pack offer visibility sync failed:', error);
      });
      return;
    }

    scheduleSync();
  });
})();
